import effectManager from '../effect';
import autoAnimationManager from '../autoAnimation';
import animationManager from '../animation';

let effect;
let autoAnimation;

/* ---------------------------------------

    -- スクロール位置で発火するやつはここ

--------------------------------------- */
export default class ScrollAnimation{
    constructor(inc){

        effect = new effectManager();
        autoAnimation = new autoAnimationManager();

        this.$target;
        this.sct = [];//スクロールアニメーションさせる要素保存
        this.scPoint = [];
        this.scShowEnd = [];
        this.scNum = 0;
        this.scNumStart = 0;

        this.status = {
            init:false,
            comp : false /* 全部処理が終わったか */
        }

        this.h;

    }
    init(){
        this.status.init = true;
        this.scNumStart = 0;
        this.$target = document.querySelectorAll('.js__tsc');
        this.scPoint = [];
        this.scNum = this.$target.length;
        effect.splitText(document.querySelectorAll(".js__tsc-splittext"),"set");
        effect.show(document.querySelectorAll(".js__tsc-show"),"set");
        effect.scale(document.querySelectorAll(".js__tsc-scale"),"set");
        this.status.comp = false;
        this.resize(window.innerHeight);

        // for(var i=0; this.scNum>i; i++) {
        //     this.scShowEnd[i] = false;
        // }
        for(let i in this.$target){

            if(this.$target[i].nodeType!=1) break; // dom要素以外は処理止める

            this.scShowEnd[i] = false;

            this.sct[i] = {
                split : [],
                show : [],
                airplane : [],
            };

            if(this.$target[i].querySelector(".js__tsc-splittext")){

                for(let j in this.$target[i].querySelectorAll(".js__tsc-splittext")){
                    if(this.$target[i].querySelectorAll(".js__tsc-splittext")[j].nodeType!=1) break; // dom要素以外は処理止める
                    this.sct[i].split[j] = this.$target[i].querySelectorAll(".js__tsc-splittext >* >*");
                }

            }
            if(this.$target[i].querySelector(".js__tsc-show")){
                for(let j in this.$target[i].querySelectorAll(".js__tsc-show")){
                    if(this.$target[i].querySelectorAll(".js__tsc-show")[j].nodeType!=1) break; // dom要素以外は処理止める
                    this.sct[i].show[j] = this.$target[i].querySelectorAll(".js__tsc-show")[j];
                }

            }
            if(this.$target[i].querySelector(".js__tsc-airplane")){
                for(let j in this.$target[i].querySelectorAll(".js__tsc-airplane")){
                    if(this.$target[i].querySelectorAll(".js__tsc-airplane")[j].nodeType!=1) break; // dom要素以外は処理止める
                    this.sct[i].airplane[j] = this.$target[i].querySelectorAll(".js__tsc-airplane")[j];
                }
            }


            // this.$target[i]

        }

        // console.log(this.$target)

        if(Useragnt.mobile) this.check(300,true);


    }
    check(inc,splash){

        // if(this.status.comp) return;

        if(this.$target){
            let i = 0
            while(i < this.scNum){

                if(!this.scShowEnd[i]&&this.scPoint[i] <= inc  ) {
                    if(this.sct[i].airplane[0]&&splash) return
                    this.scShowEnd[i] = true;

                    if(this.sct[i].split[0]) effect.splitText(this.sct[i].split[0],"show");
                    if(this.sct[i].show[0]) effect.show(this.sct[i].show,"show");
                    if(this.sct[i].airplane[0]&&!splash) autoAnimation.airplane(this.sct[i].airplane,this.h);

                    if(i==this.$target.length-1) this.status.comp = true;

                }
                i += 1

            }
        }

    }

    resize (winH) {

        if(!this.status.init) return;

        this.h = winH;

        if(this.$target){
            let _minusPoint = winH/1.5;
            this.scPoint = [];
            for( var i=this.scNumStart; i<this.scNum; i++) {

                let $scp = this.$target[i],
                    rect =  $scp.getBoundingClientRect();

                this.scPoint[i] = rect.top - _minusPoint;
            }
        }

    }
}